import { path } from "ramda";

export const scoringLogsSelector = path(["scoringLogs", "data"]);
export const csvClientIsLoadingSelector = path(["csvClients", "isLoading"]);
export const scoreCardsIsLoadingSelector = path([
  "scoreCards",
  "isLoadingGetScoreCards",
]);

export const uploadScoreCardsIsLoadingSelector = path([
  "scoreCards",
  "isLoading",
]);

export const getLastScoreCardSelector = path(["scoreCards", "lastScoreCard"]);
export const getPageInfoScoreCardLogsSelector = path([
  "scoringLogs",
  "pageInfo",
]);

export const selectAllScoreCardsRiskFactorsByType = path([
  "getAllScoreCardsRiskFactorsByType",
  "data",
]);

export const selectAllScoreCardsRiskFactorsByTypeLoading = path([
  "getAllScoreCardsRiskFactorsByType",
  "isLoading",
]);

export const selectScoreCardCalculateLoading = path([
  "scoreCardCalculate",
  "isLoading",
]);

export const selectScoreCardCalculateSubmitSuccess = path([
  "scoreCardCalculate",
  "submitSuccess",
]);

export const selectOfferIdsLoading = path(["getOfferIds", "isLoading"]);
export const selectOfferIds = path(["getOfferIds", "data"]);



// WEBPACK FOOTER //
// ./src/features/score-card/selectors/index.js